var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var toDuplex = require('./duplex');

module.exports = function (transform) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var duplex;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              duplex = toDuplex(transform); // In a transform the sink and source are connected, an error in the sink
              // will be thrown in the source also. Catch the sink error to avoid unhandled
              // rejections and yield from the source.

              duplex.sink(source).catch(function (_) {});
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(duplex.source), _awaitAsyncGenerator), "t0", 3);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};